import { render } from "./UnggahBerkas.vue?vue&type=template&id=231bff00"
import script from "./UnggahBerkas.vue?vue&type=script&lang=js"
export * from "./UnggahBerkas.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__